// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Deal, DealStatuses } from '@interfaces/deal.interfaces';
import { NavService } from '@services/nav.service';

@Component({
    selector: 'app-buyer-deals',
    templateUrl: './buyer-deals.component.html',
    styleUrls: ['./buyer-deals.component.scss'],
})
export class BuyerDealsComponent implements OnInit, OnDestroy {
    public activeDeals: Deal[] = [];
    public deals: Deal[] = [];
    private isComponentAlive = true;
    public isLoading = false;
    public mostRecentDeal: Deal = null;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly navService: NavService
    ) {
        this.deals = this.route.snapshot.data.deals.deals;

        this.mostRecentDeal = this.route.snapshot.data.deals[0];
        this.activeDeals = this.deals.filter((deal) => deal.statusId === DealStatuses.Open);
    }

    ngOnInit(): void {
        this.navService.setTitle('Vehicles');
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
